import { render, staticRenderFns } from "./AddOnsList.vue?vue&type=template&id=94359ad0&"
import script from "./AddOnsList.vue?vue&type=script&lang=js&"
export * from "./AddOnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports